import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { TestimonialCard } from "./TestimonialCard";
import { TESTIMONIALS } from "@/data/testimonials";

export const TestimonialSlider = ({ limit = 10, className = "" }) => {
  const track = useRef(null);
  const items = TESTIMONIALS.slice(0, limit);
  const scrollBy = (dir) => {
    const el = track.current;
    if (!el) return;
    const card = el.querySelector("[data-slide]");
    el.scrollBy({ left: dir * ((card?.offsetWidth || 340) + 20), behavior: "smooth" });
  };
  return (
    <section className={`bg-sand py-20 md:py-28 ${className}`} data-testid="testimonials-section" aria-labelledby="testimonials-heading">
      <div className="container-x">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <SectionHead id="testimonials-heading" eyebrow="Client testimonials" title="What Our Clients Say About Working With Us" />
          <div className="flex items-center gap-3">
            <button type="button" onClick={() => scrollBy(-1)} aria-label="Previous testimonials" className="grid h-12 w-12 place-items-center rounded-full border border-ink/20 transition-colors hover:bg-ink hover:text-paper" data-testid="testimonials-prev"><ArrowLeft className="h-4 w-4" aria-hidden /></button>
            <button type="button" onClick={() => scrollBy(1)} aria-label="Next testimonials" className="grid h-12 w-12 place-items-center rounded-full border border-ink/20 transition-colors hover:bg-ink hover:text-paper" data-testid="testimonials-next"><ArrowRight className="h-4 w-4" aria-hidden /></button>
          </div>
        </div>
      </div>
      <ul ref={track} className="mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto px-5 pb-4 [scrollbar-width:none] sm:px-8 lg:px-[max(3rem,calc((100vw-1320px)/2+3rem))] scroll-pl-5 sm:scroll-pl-8 lg:scroll-pl-[max(3rem,calc((100vw-1320px)/2+3rem))] [&::-webkit-scrollbar]:hidden" tabIndex={0} aria-label="Client testimonials">
        {items.map((t, i) => (
          <li key={t.name} data-slide className="w-[86%] shrink-0 snap-start sm:w-[420px]"><TestimonialCard t={t} index={i} /></li>
        ))}
      </ul>
      <div className="container-x mt-8">
        <Link to="/testimonials" className="btn-ghost" data-testid="all-testimonials-link">Read all {TESTIMONIALS.length} testimonials <ArrowRight className="h-4 w-4" aria-hidden /></Link>
      </div>
    </section>
  );
};
